import { CLEAR_ALL_TOAST, HIDE_TOAST, SHOW_TOAST } from '../../../ActionsConst';

const newId = () => Math.floor(Math.random() * 10000000);

export const showToast = (toastObject) => ({
  type: SHOW_TOAST,
  toast: [toastObject],
});

export const clearAllToast = () => ({
  type: CLEAR_ALL_TOAST,
});

export const hideToast = (id) => ({
  id,
  type: HIDE_TOAST,
});

export const buildAndShowErrorToast = (message) =>
  showToast({
    message,
    id: newId(),
    error: true,
  });

export const buildAndShowSuccessToast = (message) =>
  showToast({
    message,
    id: newId(),
    error: false,
  });

export const createToastId = () => Math.floor(Math.random() * 10000000);
